<template>
  <TagsInputRoot
    v-model="values"
    @update:modelValue="handleCleanUpValues"
    class="flex flex-col gap-2"
    addOnPaste
    addOnBlur
    delimiter=";"
  >
    <div
      class="sticky top-4 flex before:w-full before:h-6 before:bg-secondary before:-top-4 before:absolute"
    >
      <TagsInputInput
        ref="inputRef"
        :as="as"
        :placeholder="placeholder"
        rows="4"
        class="w-full relative text-base placeholder:text-placeholder_subtle border-primary focus:border-primary bg-primary min-h-30 rounded-md focus:ring-0 focus-visible:outline-none"
        @keydown.backspace="
          emit('update:isDirty', !isEmpty(inputRef.$el.value))
        "
        @keydown.space="handleEmptyInput"
        @keydown.enter="handleEmptyInput"
        @input="emit('update:isDirty', !isEmpty(inputRef.$el.value))"
      />
    </div>

    <div v-if="values.length > 0" class="flex flex-col gap-1">
      <TagsInputItem
        v-for="item in values"
        :key="item"
        :value="item"
        class="border bg-primary text-sm flex items-center justify-between gap-2 rounded-md pl-2.5 pr-1.5 py-1"
      >
        <div class="flex gap-2 truncate">
          <Indicator size="xs" :variant="variant" />
          <TagsInputItemText class="truncate" />
        </div>
        <TagsInputItemDelete>
          <Button size="xs" :icon="true" variant="tertiary" type="gray">
            <template #end>
              <Icon name="delete"></Icon>
            </template>
          </Button>
        </TagsInputItemDelete>
      </TagsInputItem>
    </div>
  </TagsInputRoot>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { isEmpty } from "lodash";
import {
  TagsInputInput,
  TagsInputItem,
  TagsInputItemDelete,
  TagsInputItemText,
  TagsInputRoot,
} from "radix-vue";
import { Button } from "@/SharedComponents/Buttons";
import { Icon } from "@/SharedComponents/Icon";
import { Indicator } from "@/SharedComponents/Indicator";

const emit = defineEmits(["update:modelValue", "update:isDirty"]);

const props = defineProps({
  as: { type: String, default: "input" },
  modelValue: { type: Array, default: () => [] },
  placeholder: { type: String, required: true },
  autoFocus: { type: Boolean, default: true },
  variant: { type: String, default: "asset_group" },
});

const values = ref([...props.modelValue]);
const inputRef = ref(undefined);

const handleCleanUpValues = () => {
  values.value = values.value.filter((value) => value !== "");
};

const handleEmptyInput = (event) => {
  const value = inputRef.value.$el.value.trim();

  if (!value) {
    event.preventDefault();
  }
};

onMounted(() => {
  if (props.autoFocus) {
    inputRef.value.$el.focus();
  }
});

watch(
  () => values,
  () => {
    emit("update:modelValue", values.value);
  },
  { deep: true }
);
</script>
